/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=13a1f7b6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=13a1f7b6&lang=scss"

import exportComponent from "D:\\00JH-项目\\钧舵机器人\\cn\\jodell_robotics\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__